module.exports = __webpack_public_path__ + "d8082f6bfd9ddeebee815eee6b0455d8.png";